'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import '@clara/ui/styles/clara-icons.css';
import './styles/kendo-overrides.css';
import '@clara/ui/styles/variables.css';
import '@clara/ui/styles/styles.css';
import { claraFont, itcLubalinGraphFont, nexaFont } from '../lib/fonts';
import { InternalServerErrorPage } from '../components/error/InternalServerErrorPage/InternalServerErrorPage';

interface GlobalErrorProps {
  readonly error: Error & { digest?: string };
  readonly reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body className={`${claraFont.variable} ${nexaFont.variable} ${itcLubalinGraphFont.variable}`}>
        <InternalServerErrorPage />
      </body>
    </html>
  );
}
